import { useAccess } from '@umijs/max';
import React from 'react';

type Props = {
  permission_code?: string;
  permissionCode?: string;
  children?: React.ReactNode;
};

const AuthSection: React.FC<Props> = ({ permission_code, permissionCode, children }) => {
  const access = useAccess();
  const code = permissionCode ?? permission_code;
  const allowed = !code || access?.hasPermission?.(code);
  if (!allowed) return null;
  return <>{children}</>;
};

export default AuthSection;
